import { useState, useEffect } from "react";
import { FiSearch, FiChevronUp, FiChevronDown } from "react-icons/fi";
import SitesGroupIcon from "../../../assets/img/asset_list_icon.png";

const GroupSitesPanel = ({ treeData, setIsOpen, setSelectedNode, isSideBarLoading }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedItems, setExpandedItems] = useState(new Set());

  // Expand only the first level on initial load
  useEffect(() => {
    const firstLevelIds = treeData.map((node) => node.id);
    setExpandedItems(new Set(firstLevelIds));
  }, [treeData]);

  const toggleExpand = (id) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const handleNodeClick = (node) => {
    setSelectedNode(node);
    setIsOpen(false);
    localStorage.removeItem("multiSelectSelectedValues");
    localStorage.removeItem("selectedCustomers");
  };

  const filterTree = (nodes, searchTerm) => {
    return nodes
      .map((node) => {
        const match = node.label.toLowerCase().includes(searchTerm.toLowerCase());
        const filteredChildren = filterTree(node.children, searchTerm);

        if (match || filteredChildren.length > 0) {
          return {
            ...node,
            children: filteredChildren,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    if (searchTerm) {
      const matchedNodes = filterTree(treeData, searchTerm);
      const expandAllIds = new Set();

      const collectIds = (nodes) => {
        nodes.forEach((node) => {
          expandAllIds.add(node.id);
          if (node.children.length > 0) {
            collectIds(node.children);
          }
        });
      };
      collectIds(matchedNodes);
      setExpandedItems(expandAllIds);
    } else {
      const firstLevelIds = treeData.map((node) => node.id);
      setExpandedItems(new Set(firstLevelIds));
    }
  }, [searchTerm, treeData]);

  const renderTree = (nodes) => {
    return (
      <ul className="list-none">
        {nodes.map((node) => (
          <li key={node.id}>
            <div className="flex w-full gap-2 items-center relative hover:bg-darkcolor-400 transition duration-200 p-2 mb-1">
              <img
                src={SitesGroupIcon}
                alt="Sites Group Icon"
                className="w-4 h-4 2xl:w-4 2xl:h-4"
              />
              <div onClick={() => handleNodeClick(node)} className="grow cursor-pointer px-1 py-1">
                {node.label}
              </div>
              {/* Well Count Display */}
              {node.isWell === false ? (
                <span className="rounded-md max-h-6 p-1 px-2 bg-primary-300 text-primary-700 text-sm font-medium leading-4">
                  {node.wellCount}
                </span>
              ) : node.wellCount && parseInt(node.wellCount, 10) > 0 ? (
                <span className="rounded-md max-h-6 p-1 px-2 bg-primary-300 text-primary-700 text-sm font-medium leading-4">
                  {node.wellCount}
                </span>
              ) : null}
              {node.children.length > 0 && (
                <div
                  className="cursor-pointer flex items-center justify-center w-6 h-6 rounded-full hover:bg-gray-600"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleExpand(node.id);
                  }}
                >
                  {expandedItems.has(node.id) ? <FiChevronUp /> : <FiChevronDown />}
                </div>
              )}
            </div>
            {expandedItems.has(node.id) && node.children.length > 0 && (
              <div className="pl-5">{renderTree(node.children)}</div>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="fixed left-[55px] bottom-0 top-0 flex flex-col w-[310px] 2xl:w-[410px] min-w-[310px] p-3 2xl:p-4 py-9 pb-16 z-[1000] bg-darkcolor-800">
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center mb-[10px] mt-[5px]">
          <h6>Customer & groups</h6>
        </div>
        <div className="flex mb-[16px]">
          <div className="grow mr-[9px] input-with-lefticon">
            <FiSearch className="input-icon" />
            <input
              className="input-outline-4"
              placeholder="Search by customer or group name"
              onChange={(e) => setSearchTerm(e.target.value)}
              autoComplete="off"
              value={searchTerm}
            />
          </div>
        </div>
        {/* Scrollable Area */}
        <div className="flex-grow overflow-y-auto max-h-[calc(100vh-170px)]">
          {isSideBarLoading ? (
            <div className="absolute inset-0 bg-opacity-50 flex items-center justify-center z-10">
              <div className="loader"></div>
            </div>
          ) : (
            renderTree(searchTerm ? filterTree(treeData, searchTerm) : treeData)
          )}
        </div>
      </div>
    </div>

  );
};

export default GroupSitesPanel;